import { HostCardNumbersModel, HostsModel } from '@w3lcome/types';
import { action } from 'typesafe-actions';

import { GetActualHostRequestInt } from './types';

export function getHostOfTheActualCompanyRequest({ companyId, userId }: GetActualHostRequestInt) {
  return action('@host/GET_HOST_OF_THE_ACTUAL_COMPANY_REQUEST', {
    companyId,
    userId,
  });
}

export function getHostOfTheActualCompanySuccess(host: HostsModel) {
  return action('@host/GET_HOST_OF_THE_ACTUAL_COMPANY_SUCCESS', {
    host,
  });
}

export function getHostOfTheActualCompanyFailure() {
  return action('@host/GET_HOST_OF_THE_ACTUAL_COMPANY_FAILURE');
}

export const UPDATE_HOST_CARD_NUMBER_REQUEST = '@host/UPDATE_HOST_CARD_NUMBER_REQUEST';
export const UPDATE_HOST_CARD_NUMBER_SUCCESS = '@host/UPDATE_HOST_CARD_NUMBER_SUCCESS';
export const UPDATE_HOST_CARD_NUMBER_FAILURE = '@host/UPDATE_HOST_CARD_NUMBER_FAILURE';

export const updateHostCardNumberRequest = (data: Partial<HostCardNumbersModel>) =>
  action(UPDATE_HOST_CARD_NUMBER_REQUEST, data);

export const updateHostCardNumberSuccess = (updatedCardNumber: Partial<HostCardNumbersModel>) =>
  action(UPDATE_HOST_CARD_NUMBER_SUCCESS, { updatedCardNumber });

export const updateHostCardNumberFailure = (error: any) =>
  action(UPDATE_HOST_CARD_NUMBER_FAILURE, { error });
